import StyledDialog from "../../../../../components/StyledDialog";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import NewPatientIntakeForm from "../../../../../pages/app/provider/scheduling/intake-form/NewPatientIntakeForm";

interface PatientIntakeFormModalProps {
  disclosureHost: DisclosureHost;
}

const PatientIntakeFormModal = ({
  disclosureHost,
}: PatientIntakeFormModalProps) => {
  const { opened, data, close } = disclosureHost;

  if (!opened) return null;

  return (
    <StyledDialog
      open={opened}
      onClose={close}
      dialogTitle="Intake Form"
      maxWidth="md"
      fullWidth
    >
      <NewPatientIntakeForm
        appointmentId={data?.appointmentId}
        patientId={data?.patientId}
        actionId={disclosureHost?.data?.actionId}
        showOnlyIntakeForms={data?.intakeForms?.split(",")}
        formEntries={data?.formEntries}
        onClose={close}
      />
    </StyledDialog>
  );
};

export default PatientIntakeFormModal;
